/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InspectionResponse
 */
export interface InspectionResponse {
    /**
     * 
     * @type {number}
     * @memberof InspectionResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionResponse
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof InspectionResponse
     */
    assetId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionResponse
     */
    mineLocationId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionResponse
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionResponse
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof InspectionResponse
     */
    inspectionStatusId?: number;
    /**
     * 
     * @type {Date}
     * @memberof InspectionResponse
     */
    inspectionDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InspectionResponse
     */
    completed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspectionResponse
     */
    reopened?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InspectionResponse
     */
    inspectorName?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionResponse
     */
    bucketExternalId?: string | null;
}

/**
 * Check if a given object implements the InspectionResponse interface.
 */
export function instanceOfInspectionResponse(value: object): value is InspectionResponse {
    return true;
}

export function InspectionResponseFromJSON(json: any): InspectionResponse {
    return InspectionResponseFromJSONTyped(json, false);
}

export function InspectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'mineLocationId': json['mineLocationId'] == null ? undefined : json['mineLocationId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'inspectionStatusId': json['inspectionStatusId'] == null ? undefined : json['inspectionStatusId'],
        'inspectionDate': json['inspectionDate'] == null ? undefined : (new Date(json['inspectionDate'])),
        'completed': json['completed'] == null ? undefined : json['completed'],
        'reopened': json['reopened'] == null ? undefined : json['reopened'],
        'inspectorName': json['inspectorName'] == null ? undefined : json['inspectorName'],
        'bucketExternalId': json['bucketExternalId'] == null ? undefined : json['bucketExternalId'],
    };
}

export function InspectionResponseToJSON(json: any): InspectionResponse {
    return InspectionResponseToJSONTyped(json, false);
}

export function InspectionResponseToJSONTyped(value?: InspectionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'assetId': value['assetId'],
        'mineLocationId': value['mineLocationId'],
        'siteId': value['siteId'],
        'name': value['name'],
        'inspectionStatusId': value['inspectionStatusId'],
        'inspectionDate': value['inspectionDate'] == null ? undefined : ((value['inspectionDate']).toISOString()),
        'completed': value['completed'],
        'reopened': value['reopened'],
        'inspectorName': value['inspectorName'],
        'bucketExternalId': value['bucketExternalId'],
    };
}

